import React, { useState, useEffect } from 'react';
import map from 'lodash/map';
import difference from 'lodash/difference';
import { useDispatch, useSelector } from 'react-redux';
import { DATE_SHORTCUTS, DEFAULT_GLOBAL_ACCOUNT } from '@utils/constants';
import { calcShortcutInterval, track } from '@utils';
import { Button } from 'antd';
import { setDefaultFilterInterval } from '@store/metricLens/base/actions';
import { DEFAULT_ML_FILTER, DEFAULT_ML_GRANULARITY, COLORS } from '@utils/metricLens/mapping';
import { CLICK_ML_NEW_FILTER } from '@src/utils/sensor/track';
import { changeFilterContainerVisibility } from '@store/filterContainer/actions';
import { StyledNewFilterWrapper } from './styled';
import { selectedCustomerIdSelector } from '@store/common/selectors';

const NewFilter = (props) => {
  const { setPosition, setActiveFilter, allFilters, parentRef } = props;
  const [pendingColors, setPendingColors] = useState(COLORS);
  const filterLength = allFilters.length;
  const dispatch = useDispatch();
  const selectedCustomerId = useSelector(selectedCustomerIdSelector);

  useEffect(() => {
    const appliedColors = map(allFilters, 'color');
    const newPendingColors = difference(COLORS, appliedColors);
    setPendingColors(newPendingColors);
  }, [allFilters]);

  const disPatchNewFilter = () => {
    const index = filterLength;
    let currentShortcut;
    let currentInterval;
    let currentGranularity;
    // Manual fix for Global account default load time
    if (filterLength === 0) {
      if (selectedCustomerId == DEFAULT_GLOBAL_ACCOUNT) {
        currentShortcut = DATE_SHORTCUTS.past24Hours;
      } else {
        currentShortcut = DATE_SHORTCUTS.last6Hours;
      }
      const intervals = calcShortcutInterval(currentShortcut);
      currentInterval = {
        from: intervals[0],
        to: intervals[1],
      };
      currentGranularity = DEFAULT_ML_GRANULARITY;
    } else {
      currentShortcut = allFilters[0].shortcut;
      currentInterval = allFilters[0].interval;
      currentGranularity = allFilters[0].granularity;
    }
    dispatch(
      setDefaultFilterInterval(
        DEFAULT_ML_FILTER,
        currentInterval,
        pendingColors[0],
        currentGranularity,
        currentShortcut,
        index,
      ),
    );
    setActiveFilter(index);
    setPosition(parentRef.current.children[index].getBoundingClientRect());
  };

  const handleNewFilter = () => {
    disPatchNewFilter();
    dispatch(changeFilterContainerVisibility(true));
    track({ event: CLICK_ML_NEW_FILTER });
  };

  useEffect(() => {
    if (filterLength === 0) {
      disPatchNewFilter();
    }
  }, [filterLength]);

  if (filterLength < 3) {
    return (
      <StyledNewFilterWrapper>
        <Button key="new-filter" type="link" onClick={handleNewFilter}>
          {' '}
          + Add Filter to compare
        </Button>
      </StyledNewFilterWrapper>
    );
  }
  return null;
};

export default NewFilter;
